<div *ngIf="buttonShow">
  <div class="pt-20"></div>
  <div class="center">
    <img src="../../../assets/imgs/icon.png" class="img-fluid2 logo-icon-resize">
  </div>

  <h2 id="b2borb2c" class="h2-blue-light">Welcome</h2>
  <p id="b2borb2c" class="sub-txt">Let's get started! This form will assess your existing business operations progress.</p>
  <p id="b2borb2c" class="sub-txt">Fill out ALL questions, even if you haven't started operating yet.</p>
  <p id="b2borb2c" class="sub-txt">Note: The assessment is not timed but you must complete the assessment in one session. Your answers don't save if you don't submit the assessment. </p>
  <div class="pt-2"></div>
  <div class="btn-group">
    <button mat-raised-button class="btn-blue-royal" (click)="toggleStart()"> Start</button>
  </div>
</div>

      <!--Practicality-->
      <div *ngIf="showAll">
      <mat-vertical-stepper orientation="vertical" #stepper>
        <mat-step [stepControl]="assessmentForm">
      <form *ngIf="assessmentForm" [formGroup]="assessmentForm">
            <!-- <div formGroupName="practicalBusiPlanArray"> -->
              <ng-template matStepLabel>Company History</ng-template>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Business Name" formControlName="busiName">
                    <mat-error *ngIf="assessmentForm.controls['busiName'].hasError('required')">
                      Business Name is
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="First name" formControlName="busiFirstName">
                    <mat-error *ngIf="assessmentForm.controls['busiFirstName'].hasError('required')">
                      First name is
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Last name" formControlName="busiLastName">
                    <mat-error *ngIf="assessmentForm.controls['busiLastName'].hasError('required')">
                      Last name is
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Email" type="email" formControlName="busiEmail">
                    <mat-error *ngIf="assessmentForm.controls['busiEmail'].hasError('required')">
                      Email
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Phone Number" type="text" formControlName="busiTelephone">
                    <mat-error *ngIf="assessmentForm.controls['busiTelephone'].hasError('required')">
                      Phone number
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>Is this an existing company?</label>
                    <mat-select placeholder=" " formControlName="practicalCompHistoryExistingCompany">
                      <mat-option (onSelectionChange)="handleQ2($event, tExistingCompany.name)"  
                        *ngFor="let tExistingCompany of boolAnswer" [value]="tExistingCompany">
                        {{ tExistingCompany.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['practicalCompHistoryExistingCompany']">
                      Please select yes or no
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col" #existingBase style="display:none">
                  <mat-form-field class="full-width">
                    <label>Do you have an existing customer base?</label>
                    <mat-select placeholder="" formControlName="practicalCompHistoryExistingCustomerBase">
                      <mat-option (onSelectionChange)="handleQ3($event, tExistingCustomerBase.name)"
                        *ngFor="let tExistingCustomerBase of boolAnswer" [value]="tExistingCustomerBase">
                        {{ tExistingCustomerBase.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['practicalCompHistoryExistingCustomerBase']">
                      Please select yes or no
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div>
                <button mat-button matStepperNext>Next</button>
              </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="assessmentForm">
          <form [formGroup]="assessmentForm">
            <ng-template matStepLabel>Strategy</ng-template>
              <div class="row"> 
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>What is your method of operations? Select all that apply. </label>
                    <mat-select placeholder="" formControlName="practicalStrategyOperationsMethods" multiple>
                      <mat-option  *ngFor="let pStrategyOperationsMethods of practicalStrategyOperationsMethods" [value]="pStrategyOperationsMethods">
                        {{pStrategyOperationsMethods.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['practicalStrategyOperationsMethods'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col" #operatingStrategyCustomerService style="display:none">
                  <mat-form-field class="full-width">
                    <label>How would others describe your customer service?
                    </label>
                    <mat-select placeholder="" formControlName="practicalStrategyCustomerService">
                      <mat-option  *ngFor="let pStrategyCustomerService of practicalStrategyCustomerService" [value]="pStrategyCustomerService">
                        {{pStrategyCustomerService.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['practicalStrategyCustomerService'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col" #operatingStrategyCustomerEngagement style="display:none">
                  <mat-form-field class="full-width">
                    <label> How is your customer engagement?
                    </label>
                    <mat-select placeholder="" formControlName="practicalStrategyCustomerEngagement">
                      <mat-option  *ngFor="let pStrategyCustomerEngagement of practicalStrategyCustomerEngagement" [value]="pStrategyCustomerEngagement">
                        {{pStrategyCustomerEngagement.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['practicalStrategyCustomerEngagement'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
            </div>
                  <div class="row"> 
                  <div class="col">
                    <mat-expansion-panel (opened)="panelOpenState = true"
                    (closed)="panelOpenState = false" >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                        What elements are in your business plan?
                        </mat-panel-title>
                      </mat-expansion-panel-header>   
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Business Plan Sections</th>
                          </tr>
                        </thead>
                       
                        <tbody>
                           <div formArrayName="practicalBusiPlanArray">
                             
                          <tr>
                           
                              <td>
                                Executive Summary
                              </td>
                              <mat-radio-group formControlName="practicalBusiPlanExecSum">
                            <td class="td-style "> 
                              Does not exist
                              <mat-radio-button  [value]='0' ></mat-radio-button>
                            </td>
                            <td  class="td-style ">
                              Needs work
                              <mat-radio-button [value]='1' ></mat-radio-button>
                            </td>
                            <td class="td-style " >
                              Good to go
                              <mat-radio-button [value]='2'></mat-radio-button>
                            </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Mission, Vision, Goal</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanMisVisGoal">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Business Summary</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanBusiSum">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Services and Products Description</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanOfferDescrip">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Industry Overview</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanIndustryOverview">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Target Market</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanTargetMarket">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Marketing Summary</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanMarketingSummary">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Sales Strategy</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanSaleStrategy">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Team Overview</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanTeamOverview">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Financial Projections</p>
                            </td>
                            <mat-radio-group formControlName="practicalBusiPlanFinancialProjections">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          </div>
                        </tbody>
                      </table>
             
                     </mat-expansion-panel>
              </div>
              </div>
              <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext>Next</button>
              </div>
          </form>
          </mat-step>
      <mat-step [stepControl]="assessmentForm">
        <form [formGroup]="assessmentForm">
          <ng-template matStepLabel>Legal</ng-template>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <label>What is your registration status?</label>
            <mat-select placeholder="" formControlName="busiRegType">
              <mat-option *ngFor="let registration of busiRegType" [value]="registration">
                {{ registration.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['busiRegType'].hasError('required')">
              Registration Type
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col" #operating2 style="display:none">
          <mat-form-field class="full-width">
            <label>Do you have a solid operating agreement?</label>
            <mat-select placeholder="" formControlName="practicalLegalOpAgreement" >
              <mat-option *ngFor="let pLegalOpAgreement of practicalLegalOpAgreement" [value]="pLegalOpAgreement">
                {{ pLegalOpAgreement.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['practicalLegalOpAgreement'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        </div>
        <div class="row">
        <div class="col" #operating3 style="display:none">
          <mat-form-field class="full-width">
            <label>Do you have good disclaimers?</label>
            <mat-select placeholder="" formControlName="practicalLegalDisclaimers">
              <mat-option *ngFor="let pLegalDisclaimers of practicalLegalDisclaimers" [value]="pLegalDisclaimers">
                {{ pLegalDisclaimers.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['practicalLegalDisclaimers'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="full-width">
            <label>In terms of intellectual property, the business...</label>
            <mat-select placeholder="" formControlName="practicalLegalIP" >
              <mat-option *ngFor="let pLegalIP of practicalLegalIP" [value]="pLegalIP">
                {{ pLegalIP.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['practicalLegalIP'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
        </form>
        </mat-step>
        <mat-step [stepControl]="assessmentForm">
          <form [formGroup]="assessmentForm">
            <ng-template matStepLabel>Finance</ng-template>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How much financing or capital are you looking for?</label>
                  <mat-select placeholder=" " formControlName="capitalSeeking">
                    <mat-option *ngFor="let cSeeking of capitalSeeking" [value]="cSeeking">
                      {{ cSeeking.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['capitalSeeking']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col" >
                <mat-form-field class="full-width">
                <label>How do you plan to, or currently, make money?</label>
                <mat-select placeholder="" formControlName="revModel" multiple>
                  <mat-option *ngFor="let rModel of revModel" [value]="rModel">
                    {{ rModel.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="assessmentForm.controls['revModel']">
                  Please select yes or no
                </mat-error>
              </mat-form-field>
              </div>
              </div>
              <div class="row">
              <div class="col" #operating4 style="display:none">
                <mat-form-field class="full-width">
                  <label>Do you actively use a payment processing system or have one set up?</label>
                  <mat-select placeholder=" " formControlName="practicalFinancePaymentSystem">
                    <mat-option *ngFor="let pFinancePaymentSystem of practicalFinanceSystem" [value]="pFinancePaymentSystem">
                      {{ pFinancePaymentSystem.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['practicalFinancePaymentSystem']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col" #operating5 style="display:none">
                <mat-form-field class="full-width">
                  <label>Do you actively use accounting software or have one set up?</label>
                  <mat-select placeholder=" " formControlName="practicalFinanceAccountingSystem">
                    <mat-option *ngFor="let pFinanceAccountingSystem of practicalFinanceSystem" [value]="pFinanceAccountingSystem">
                      {{ pFinanceAccountingSystem.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['practicalFinanceAccountingSystem']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
              <div class="row">
                <mat-expansion-panel (opened)="panelOpenState = true"
                (closed)="panelOpenState = false" style="width: 50%">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      What’s your level of comfortability in understanding the following?
                    </mat-panel-title>
                  </mat-expansion-panel-header>    
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Finance Topic</th>
                    </tr>
                  </thead>
                  <tbody>
                     <div formArrayName="practicalFinance">
                      <tr>
                        <td>
                        <p>Financial statements</p>
                      </td>
                      <mat-radio-group formControlName="practicalFinanceStatements">
                      <td>
                        No Clue
                        <mat-radio-button [value] = '0' ></mat-radio-button>
                      </td>
                      <td>
                        Somewhat
                        <mat-radio-button [value] = '1'></mat-radio-button>
                      </td>
                      <td>
                        Good to go
                        <mat-radio-button [value] = '2'></mat-radio-button>
                      </td>
                    </mat-radio-group>
                    </tr>
                    <tr>
                      <td>
                        <p>Tax laws related to your business</p>
                      </td>
                      <mat-radio-group formControlName="practicalFinanceTaxes">
                        <td>
                          No Clue
                          <mat-radio-button [value] = '0' ></mat-radio-button>
                        </td>
                        <td>
                          Somewhat
                          <mat-radio-button [value] = '1'></mat-radio-button>
                        </td>
                        <td>
                          Good to go
                          <mat-radio-button [value] = '2'></mat-radio-button>
                        </td>
                    </mat-radio-group>
                    </tr>
                    <tr>
                      <td>
                        <p>Accounting/bookkeeping</p>
                      </td>
                      <mat-radio-group formControlName="practicalFinanceAccounting">
                        <td>
                          No Clue
                          <mat-radio-button [value] = '0' ></mat-radio-button>
                        </td>
                        <td>
                          Somewhat
                          <mat-radio-button [value] = '1'></mat-radio-button>
                        </td>
                        <td>
                          Good to go
                          <mat-radio-button [value] = '2'></mat-radio-button>
                        </td>
                    </mat-radio-group>
                    </tr>
                    <tr>
                      <td>
                        <p>Calculating Cost of Goods Sold/Expenses</p>
                      </td>
                      <mat-radio-group formControlName="operatingFinancialCOGSExp">
                        <td>
                          No Clue
                          <mat-radio-button [value] = '0' ></mat-radio-button>
                        </td>
                        <td>
                          Somewhat
                          <mat-radio-button [value] = '1'></mat-radio-button>
                        </td>
                        <td>
                          Good to go
                          <mat-radio-button [value] = '2'></mat-radio-button>
                        </td>
                    </mat-radio-group>
                    </tr>
                    </div>
                  </tbody>
                </table>
            </mat-expansion-panel>
          </div>
            
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>
            </form>
            </mat-step>
            <mat-step [stepControl]="assessmentForm">
              <form [formGroup]="assessmentForm">
                <ng-template matStepLabel>Marketing</ng-template>
                <div class ="row" #notoperating1 style="display:block">
                  If you are not operating yet, you will not see questions here. Click "Next".
                </div>
                <div class="row">
                  <div class="col"  #operating6 style="display:none">
                    <mat-form-field class="full-width">
                      <label>Do you have a website?</label>
                      <mat-select placeholder=" " formControlName="practicalMarketingWebsite">
                        <mat-option *ngFor="let pMarketingWebsite of practicalMarketingWebsite" [value]="pMarketingWebsite">
                          {{ pMarketingWebsite.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['practicalMarketingWebsite']">
                        Please select one
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col" #operating7 style="display:none">
                    <mat-form-field class="full-width">
                      <label>How consistent and professional is your brand?</label>
                      <mat-select placeholder=" " formControlName="practicalMarketingBrand">
                        <mat-option *ngFor="let pMarketingBrand of practicalMarketingBrand" [value]="pMarketingBrand">
                          {{ pMarketingBrand.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['practicalMarketingBrand']">
                        Please select yes or no
                      </mat-error>
                    </mat-form-field>
                  </div>
                  </div>
                  <div class="row">
                  <div class="col" #operating8 style="display:none">
                    <mat-form-field class="full-width">
                      <label>How comfortable are you in your marketing efforts and understanding how effective they are?</label>
                      <mat-select placeholder=" " formControlName="practicalMarketingEffectiveness">
                        <mat-option *ngFor="let pMarketingEffectiveness of practicalMarketingEffectiveness" [value]="pMarketingEffectiveness">
                          {{ pMarketingEffectiveness.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['practicalMarketingEffectiveness']">
                        Please select yes or no
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col" #operating9 style="display:none">
                    <mat-form-field class="full-width">
                      <label>Do you have material to showcase your business when networking? (Ex. Capabilities statement, business cards, etc.)</label>
                      <mat-select placeholder=" " formControlName="practicalMarketingNetworkMaterial">
                        <mat-option *ngFor="let pMarketingNetworkMaterial of practicalMarketingNetworkMaterial" [value]="pMarketingNetworkMaterial">
                          {{ pMarketingNetworkMaterial.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['practicalMarketingNetworkMaterial']">
                        Please select yes or no
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col" #operatingMarketingEmailList style="display:none">
                    <mat-form-field class="full-width">
                      <label>Do you have an email marketing list?</label>
                      <mat-select placeholder=" " formControlName="practicalMarketingEmailList">
                        <mat-option *ngFor="let pMarketingList of practicalMarketingEmailList" [value]="pMarketingList">
                          {{ pMarketingList.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['practicalMarketingEmailList']">
                        Please select yes or no
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col" #operatingMarketingSocialMedia style="display:none">
                    <mat-form-field class="full-width">
                      <label>Which best describes your social media presence?</label>
                      <mat-select placeholder=" " formControlName="practicalMarketingSocialMedia">
                        <mat-option *ngFor="let pMarketingSocialMedia of practicalMarketingSocialMedia" [value]="pMarketingSocialMedia">
                          {{ pMarketingSocialMedia.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['practicalMarketingSocialMedia']">
                        Please select yes or no
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
        </mat-step>
            <mat-step [stepControl]="assessmentForm">
              <form [formGroup]="assessmentForm">
                <ng-template matStepLabel>Business Operations</ng-template>
                <div class ="row" #notoperating2 style="display:block">
                  If you are not operating yet, you will not see questions here. Click "Next".
                </div>
            <div class="row">
              <div class="col" #operating10 style="display:none">
                <mat-form-field class="full-width">
                  <label>Do you have, or have identified, a system that organizes your customer information (CRM)?</label>
                  <mat-select placeholder="" formControlName="practicalOpCRM">
                    <mat-option *ngFor="let pCRM of YesNoNotSure" [value]="pCRM">
                      {{ pCRM.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['practicalOpCRM'].hasError('required')">
                    Please enter a value
                  </mat-error>
                </mat-form-field>
        </div>
        <div class="col" #operating11 style="display:none">
          <mat-form-field class="full-width">
            <label>Do you have thorough standard operating procedures on how to run your business?</label>
            <mat-select placeholder="" formControlName="practicalOpSOP" >
              <mat-option *ngFor="let pSOP of YesNoNotSure" [value]="pSOP">
                {{ pSOP.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['practicalOpSOP'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col" #operating12 style="display:none">
          <mat-form-field class="full-width" >
            <label>Do you have a consistent and stable production process?</label>
            <mat-select placeholder="" formControlName="practicalOpProductionProcess">
              <mat-option *ngFor="let pProductionProcess of YesNoNotSure2" [value]="pProductionProcess">
                {{ pProductionProcess.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['practicalOpProductionProcess'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
        </form>
        </mat-step>
        <mat-step [stepControl]="assessmentForm">
          <form [formGroup]="assessmentForm" novalidate (ngSubmit)="onSubmit()">
            <!--</div>-->
            <ng-template matStepLabel>Hiring & HR</ng-template>
            <div class="col" #notoperating3 style="display:block">
              If you are not operating yet, you will not see questions here. To submit the form, select "I agree" and "Submit".
            </div>
            <div class="row">
              <div class="col" #operating13 style="display:none">
                <mat-form-field class="full-width">
                  <label>What do you currently do to foster company culture and employee retention?</label>
                  <mat-select placeholder="" formControlName="practicalHREmployeeRetention" multiple>
                    <mat-option *ngFor="let pEmployeeRetention of practicalHREmployeeRetention" [value]="pEmployeeRetention">
                      {{ pEmployeeRetention.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['practicalHREmployeeRetention'].hasError('required')">
                    Please enter a value
                  </mat-error>
                </mat-form-field>
        </div>
        </div>
        <div class="row">
        <div class="col" #operating14 style="display:none">
          <mat-expansion-panel (opened)="panelOpenState = true"
          (closed)="panelOpenState = false" style="width: 50%">
            <mat-expansion-panel-header>
              <mat-panel-title>
                What is your level of quality and comfortability for these hiring practices?
              </mat-panel-title>
            </mat-expansion-panel-header>    
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Hiring Practice</th>
              </tr>
            </thead>
            <tbody>
               <div formArrayName="practicalHiringPractices">
                <tr>
                  <td>
                  <p>Interviewing</p>
                </td>
                <mat-radio-group formControlName="practicalHiringPracticesInterviewing">
                <td>
                  Does not exist
                  <mat-radio-button [value] = '0' ></mat-radio-button>
                </td>
                <td>
                  Needs work
                  <mat-radio-button [value] = '1'></mat-radio-button>
                </td>
                <td>
                  Good to go
                  <mat-radio-button [value] = '2'></mat-radio-button>
                </td>
              </mat-radio-group>
              </tr>
              <tr>
                <td>
                  <p>Job Descriptions</p>
                </td>
                <mat-radio-group formControlName="practicalHiringPracticesJobDescrp">
                  <td>
                    Does not exist
                    <mat-radio-button [value] = '0' ></mat-radio-button>
                  </td>
                  <td>
                    Needs work
                    <mat-radio-button [value] = '1'></mat-radio-button>
                  </td>
                  <td>
                    Good to go
                    <mat-radio-button [value] = '2'></mat-radio-button>
                  </td>
              </mat-radio-group>
              </tr>
              <tr>
                <td>
                  <p>Onboarding Process</p>
                </td>
                <mat-radio-group formControlName="practicalHiringPracticesOnboarding">
                  <td>
                    Does not exist
                    <mat-radio-button [value] = '0' ></mat-radio-button>
                  </td>
                  <td>
                    Needs work
                    <mat-radio-button [value] = '1'></mat-radio-button>
                  </td>
                  <td>
                    Good to go
                    <mat-radio-button [value] = '2'></mat-radio-button>
                  </td>
              </mat-radio-group>
              </tr>
              <tr>
                <td>
                  <p>HR/employee Maintenance</p>
                </td>
                <mat-radio-group formControlName="practicalHiringPracticesHR">
                  <td>
                    Does not exist
                    <mat-radio-button [value] = '0' ></mat-radio-button>
                  </td>
                  <td>
                    Needs work
                    <mat-radio-button [value] = '1'></mat-radio-button>
                  </td>
                  <td>
                    Good to go
                    <mat-radio-button [value] = '2'></mat-radio-button>
                  </td>
              </mat-radio-group>
              </tr>
              </div>
            </tbody>
          </table>
      </mat-expansion-panel>
    </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col">
                <mat-checkbox formControlName="acceptTerms" #tc>
                  By selecting 'I agree' and clicking submit, you agree to our <a target="_blank"
                    href="http://sustainible.io/privacy-policy/">Privacy Policy</a> and <a target="_blank"
                    href="http://sustainible.io/terms-conditions/">Terms and Conditions</a>.
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button>Submit</button>
        </div>
        </form>
        </mat-step>
        </mat-vertical-stepper>
      </div>


